import { Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from './environment';

import { MockHttpInterceptorBase } from '@library/common/http';

import { Routes } from './routes.mock';

@Injectable()
export class MockHttpInterceptor extends MockHttpInterceptorBase {
   routes = Routes;

   isMock(): boolean {
      return environment.mock;
   }
}

export let mockHttpInterceptor = {
   provide: HTTP_INTERCEPTORS,
   useClass: MockHttpInterceptor,
   multi: true
};
